/* eslint-disable react/function-component-definition */
import { Dialog, Transition } from '@headlessui/react';
import React, { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import SecondaryButton from '../SecondaryButton';

interface Props {
  text: string;
  to?: string;
  title: string;
  btnText?: string;
  closeModal: Function;
}

const Modal: React.FC<Props> = ({ text, to, title, btnText, closeModal }) => {
  const navigate = useNavigate();
  return (
    <Transition appear show as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => closeModal()}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0">
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95">
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-primary">
                  {title}
                </Dialog.Title>
                <div className="mt-2">
                  <p className="text-sm text-gray-500">{text}</p>
                </div>

                <div className="flex mt-4 justify-items-center">
                  <SecondaryButton className="w-auto" text={btnText} onClick={() => to && navigate(to)} />
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

Modal.defaultProps = {
  to: undefined,
  btnText: 'Accedi',
};

export default Modal;
